import _ from 'lodash';
// Helper functions for filtering
export const defaultMatcher = (node, nodeID) => node.node === nodeID;

export const findTreeNode = (node, filter, matcher = defaultMatcher) => {
  if (matcher(node, filter)) {
    return { ...node };
  }
  if (!node.children && (!node.length || node.length === 0)) {
    return false;
  }

  const nodeArray = node.children ? node.children : node;
  for (let i = 0; i < nodeArray.length; i += 1) {
    const searchedNode = findTreeNode(nodeArray[i], filter, matcher);
    if (searchedNode) {
      return searchedNode;
    }
  }
  return false;
};

export const updateTreeNode = (
  node,
  updatedProps,
  filter,
  matcher = defaultMatcher,
) => {
  if (matcher(node, filter)) {
    return true;
  }
  if (!node.children && (!node.length || node.length === 0)) {
    return false;
  }

  const nodeArray = node.children ? node.children : node;
  for (let i = 0; i < nodeArray.length; i += 1) {
    const searchedNode = updateTreeNode(
      nodeArray[i],
      updatedProps,
      filter,
      matcher,
    );
    if (searchedNode) {
      if (searchedNode === true) {
        nodeArray[i] = {
          ...nodeArray[i],
          ...updatedProps,
          objectType: 'operand',
        };
      }
      return nodeArray;
    }
  }
  return false;
};

export const getDeepTreeCopy = dataTree => {
  const treeString = JSON.stringify(dataTree);
  return JSON.parse(treeString);
};

export const filterTreeNode = (node, filterValue, matcher = defaultMatcher) => {
  const filteredTree = node.filter(currentNode => {
    if (currentNode.children)
      currentNode.children = filterTreeNode(
        currentNode.children,
        filterValue,
        matcher
      );

    return matcher(currentNode, filterValue);
  });
  return filteredTree;
};


// To remove nodes from one tree (node) at any level, if it present in another tree (filterTree)
export const removeTreeNode = (node, filterTree, matcher = defaultMatcher) => {
  // recursively call children nodes to remove the nodes
  const nodeArray = node.children ? node.children : node;
    for (let i = 0; i < nodeArray.length; i += 1) {
      _.remove(filterTree, (filterTreeNode) => {
        return matcher (filterTreeNode, nodeArray[i].node)
      });

      removeTreeNode(nodeArray[i], filterTree, matcher);
  }
  return true;
};



export const flattenTreeNodeLablesWithParent = (
  node,
  flatTreeLabelTextObj,
  labelSeparator = ' / '
) => {
  if (node.textPath) {
    const labelKey = node.textPath;

    // To get parent unique textPath
    const parentNodeTextPath = _.includes(node.textPath, '.')
      ? node.textPath.slice(0, node.textPath.lastIndexOf('.'))
      : node.textPath;

    // To concatenate the parent label text with current node
    const lableText =
      (flatTreeLabelTextObj[parentNodeTextPath]
        ? flatTreeLabelTextObj[parentNodeTextPath] + labelSeparator
        : '') + node.shortText;

    const nodeLabel = {};
    nodeLabel[labelKey] = {};
    nodeLabel[labelKey] = lableText;

    // Join resultant with previous object as a single object
    _.assign(flatTreeLabelTextObj, nodeLabel);
  }

  // recursively call children nodes to concatenate its lable
  const nodeArray = node.children ? node.children : node;
  for (let i = 0; i < nodeArray.length; i += 1) {
    flattenTreeNodeLablesWithParent(nodeArray[i], flatTreeLabelTextObj);
  }

  return flatTreeLabelTextObj;
};

// To filter out nodes between the range of nodes starting from selectedFirstItem to selectedLastItem
export const selectTreeNodesBetweenNodes = (
  selectedFirstItem,
  selectedLastItem,
  node,
  selectedItems
) => {
  let selectedLastItemNode = parseInt(selectedLastItem.node);
  let selectedFirstItemNode = parseInt(selectedFirstItem.node);

  // To make top to bottom traversal
  if (selectedFirstItemNode > selectedLastItemNode) {
    const temp = selectedFirstItemNode;
    selectedFirstItemNode = selectedLastItemNode;
    selectedLastItemNode = temp;
  }

  // recursively call for children nodes to select nodes between nodes
  const nodeArray = node.children ? node.children : node;

  for (let i = 0; i < nodeArray.length; i += 1) {
    const item = nodeArray[i];

    if (
      parseInt(item.node) <= selectedLastItemNode &&
      parseInt(item.node) >= selectedFirstItemNode
    ) {
      selectedItems.push(item);
    }

    selectTreeNodesBetweenNodes(
      selectedLastItem,
      selectedFirstItem,
      nodeArray[i],
      selectedItems
    );
  }
  return node;
};


// To ignore if any items in node present in selectedItemsToFindIn
export const ignoreDuplicatesBetweenTreeNodes = (node, selectedItemsToFindIn, remainingItems) => {
  // recursively call for children nodes to ignore its sub-categories
  const nodeArray = node.children ? node.children : node;

  for (let i = 0; i < nodeArray.length; i += 1) {
    const item = nodeArray[i];

    // If only selected node does not present in selectedItemsToFindIn proceed to add
    // otherwise skip the process
    if (
      parseInt(item.node) &&
      !findTreeNode(selectedItemsToFindIn, item.node)
    ) {
      remainingItems.push(item);
    }

    ignoreDuplicatesBetweenTreeNodes(
      nodeArray[i],
      selectedItemsToFindIn,
      remainingItems
    );
  }
  return true;
};